import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import fetchAllMortgageProviderRates from '../functions/fetchAllMortgageProviderRates';
import fetchBestMortgageProviderRates from '../functions/fetchBestMortgageProviderRates';


function useAllProviderRates({
    columns,
    providerType,
    providers,

    initialProviderRates,
    initialBestRates,
    initialCity,
    initialProvinceCode,
}) {
    const { locale } = useIntl();
    const [ isFetching, setIsFetching ] = useState(false);
    const [ bestRates, setBestRates ] = useState(initialBestRates);
    const [ providerRates, setProviderRates ] = useState(initialProviderRates);
    const [ location, setLocation ] = useState({
        city: initialCity.slug,
        province: initialProvinceCode,
    });
    const queryParams = columns.map(header => ({
        type: header.type,
        term: header.term * 12,
    }));

    useEffect(() => {
        async function fetchRowData() {
            setIsFetching(true);

            let allBestRates = [], allProviderRates = [];

            try {
                [ allBestRates, allProviderRates ] = await Promise.all([
                    // Only call best rates if needed
                    initialBestRates
                        ? fetchBestMortgageProviderRates({
                            typeTerms: queryParams,
                            city: location.city,
                            province: location.province,
                            locale,
                        })
                        : [],
                    fetchAllMortgageProviderRates({
                        params: queryParams.map(param => ({
                            ...param,
                            city: location.city,
                            province: location.province,
                        })),
                        providers,
                        locale,
                        ...(!providers && providerType),
                    }),
                ]);
            } catch {
                // We don't have to do anything with the error since
                //  the fetch functions above will noticeError for us
                setIsFetching(false);
            }

            // Preserve the original order of our pre-fetched providers array, if supplied
            providers && allProviderRates.sort((a, b) => {
                const indexA = providers.indexOf(a.provider.slug);
                const indexB = providers.indexOf(b.provider.slug);

                return indexA < indexB ? -1 : 1;
            });

            setIsFetching(false);

            setBestRates(allBestRates);
            setProviderRates(allProviderRates);
        }

        if (columns) {
            fetchRowData();
        }
    }, [ location?.city, location?.province, providerType, providers, !!initialBestRates ]);

    function handleChangeLocation(data) {
        // data may be null due to an unparseable location or API failures
        if (!data) {
            return;
        }

        const { slug, province } = data;

        setLocation({
            city: slug,
            province: province.code,
        });
    }

    return {
        providerRates,
        bestRates,
        location,
        isFetching,
        handleChangeLocation,
    };
}

export default useAllProviderRates;
